module.exports = __webpack_public_path__ + "static/cabbage-e47914f06f863433cd0adaf25a512616.png";